export class OrdemDeServicoFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getOrdemDeServicos(filter) {
    return this.instance.get('/v1/ordem-de-servicos', {
      params: filter || null,
    });
  }

  getOrdemDeServico(id, filter) {
    return this.instance.get(`/v1/ordem-de-servicos/${id}`, {
      params: filter || null,
    });
  }

  insertOrdemDeServico(data) {
    return this.instance.post('/v1/ordem-de-servicos', data);
  }

  editOrdemDeServico(data, id) {
    return this.instance.put(`/v1/ordem-de-servicos/${id}`, data);
  }

  deleteOrdemDeServico(id) {
    return this.instance.delete(`/v1/ordem-de-servicos/${id}`);
  }

  concluirOrdemDeServico(id) {
    return this.instance.patch(`/v1/ordem-de-servicos/${id}/concluido`);
  }

  pendenteOrdemDeServico(id) {
    return this.instance.patch(`/v1/ordem-de-servicos/${id}/pendente`);
  }

  duplicarOrdemDeServico(id) {
    return this.instance.post(`/v1/ordem-de-servicos/${id}/duplicado`);
  }
}

export default (...params) => new OrdemDeServicoFactory(...params);
